import { mxgraphInstance } from './mxgraphFactory';

/**
 * mxClient
 */
export const mxClient = mxgraphInstance.mxClient;